import { Program, Curriculum } from "../../../models/ISchema";
import { getSelectablePrograms } from "./filterAllPrograms";

type IOption = {
  label: string;
  value: string;
};

export const filterByCurriculum = (
  programs: Program[],
  department: IOption,
  curriculums: Curriculum[],
  modality: IOption,
  shift: IOption,
  program: IOption,
  campus?: IOption,
): Curriculum[] => {
  // Filter programs by filters
  const selectablePrograms = getSelectablePrograms(
    programs,
    campus,
    department,
    modality,
    shift,
    program,
  );

  // Filter result programs by shift
  const modalitiesIdsFromSelectablePrograms = selectablePrograms.map(program => program.id);

  const selectableCurriculums = curriculums.filter(item => {
    return modalitiesIdsFromSelectablePrograms.includes(item.program.id);
  });

  return selectableCurriculums;
};
